// angular
import {Injectable} from "@angular/core";
import {BehaviorSubject, Subject} from "rxjs";
// interfaces
import {IMessage} from "../interfaces/message.interface";
import {IChat} from "../interfaces/chat.interface";
import {IEmploysPeople} from "../interfaces/member.interface";

@Injectable({providedIn: "root"})
export class StateManagementService {
  // chats global states
  public allChats$ = new Subject<IChat[]>();
  public allChatsCount$ = new Subject<number>();
  public totalChatPages$ = new Subject<number>();

  public oneChatById$ = new Subject<IChat>();
  public isChatExist$ = new Subject<boolean>();
  public isError$ = new BehaviorSubject<boolean>(false);
  public errorMessage$ = new Subject();
  // messages global state
  public allMessages$ = new Subject<IMessage[]>();
  public allMessagesCount$ = new Subject<number>();
  public totalMessagesPages$ = new Subject<number>();

  public pinnedMessages$ = new Subject<IMessage>();
  public isEditMessageMod$ = new Subject<boolean>();
  public editMessageContent$ = new Subject<IMessage>();
  // members global state
  public projectEmploysPeoples$ = new Subject<IEmploysPeople[]>();
  // toggle pages
  public togglePvList$ = new BehaviorSubject<boolean>(false);
  public toggleChatPage$ = new BehaviorSubject<boolean>(false);
  public toggleDetailsPage$ = new BehaviorSubject<boolean>(false);
  // is popup mode
  public isPopUpMode$ = new BehaviorSubject<boolean>(false);
  // firebase
  public firebaseData$ = new Subject<any>();
}
